module.exports = __webpack_public_path__ + "img/bookmark.1447327c.svg";